import React, { lazy } from 'react';
import { CheckIcon, CreditCardIcon, LockKeyholeIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
const productImage = 'https://cdn.magicpatterns.com/uploads/wKiYjBGbfXPbsstPzCSzzt/Diseno-sin-titulo-_67_.webp';
const items = ['6 volumi didattici completi di Pilates', '5 bonus strategici esclusivi', '60+ sessioni pronte all’uso', 'Accesso a vita al materiale digitale', 'PDF alta qualità per Tablet e Stampa'];
export function PricingSection() {
  return <section id="offerta" data-cta-block className="bg-[#fff7fb] px-5 py-20" data-id="element-178" data-mp="1ncwph7bw4nf7">
      <div className="mx-auto max-w-xl text-center" data-id="element-179" data-mp="1s7smklvzi0z6">
        <p className="inline-block rounded-full bg-[#241322] px-5 py-2 text-xs font-bold uppercase tracking-widest text-white" data-id="element-180" data-mp="1x8gldtqgfm3y">
          Offerta speciale di lancio
        </p>
        <h2 className="mt-5 font-display text-4xl font-bold uppercase leading-none text-[#241322] sm:text-5xl" data-id="element-181" data-mp="2up6oft9qc1n">
          Tutto incluso,{' '}
          <span className="text-emerald-700" data-id="element-182" data-mp="7ul7k66o5ncz">un unico prezzo.</span>
        </h2>
        <p className="mt-3 text-sm font-semibold text-slate-600" data-id="element-183" data-mp="1mgy46xewhepi">
          Nessun abbonamento. Nessuna sorpresa.
        </p>
        <article className="mt-10 overflow-hidden rounded-3xl border border-emerald-950/10 bg-white text-center shadow-xl" data-id="element-184" data-mp="1hodf296xvpsb">
          <header className="border-t-4 border-emerald-500 bg-[#241322] px-6 py-7" data-id="element-185" data-mp="1cosha23i9nh6">
            <h3 className="font-display text-3xl font-bold uppercase text-white" data-id="element-186" data-mp="17tlhv6h9r4y2">
              PILATES PRONTA™ — Pacchetto completo
            </h3>
            <p className="mt-2 text-sm font-semibold text-emerald-300" data-id="element-187" data-mp="20fxvydxpm9pw">
              6 Volumi + 5 Bonus Strategici
            </p>
          </header>
          <div className="p-7 sm:p-10" data-id="element-188" data-mp="1vfjmcrggmrpr">
            <img src={productImage} alt="Pacchetto completo PILATES PRONTA" width={1080} height={1080} loading="lazy" className="mx-auto -mt-3 mb-3 w-full max-w-md object-contain" data-id="element-189" data-mp="1rg19miyslmy0" />
            <div id="dettagli-offerta" className="mb-8 scroll-mt-3 border-y border-emerald-950/10 py-7" data-id="element-190" data-mp="g0m42qsipmra">
              <p className="mb-5 text-xs font-bold uppercase tracking-widest text-[#241322]" data-id="element-191" data-mp="hhrs2va92tm3">
                Cosa include
              </p>
              <ul className="grid gap-3 text-left sm:grid-cols-2" data-id="element-192" data-mp="mft8t9k7egue">
                {items.map(item => <li key={item} className="flex items-center gap-2 text-sm font-semibold text-[#241322]" data-id="element-193" data-mp="7kdcexw5i8uu">
                    <span className="grid h-5 w-5 place-items-center rounded-full bg-emerald-100" data-id="element-194" data-mp="chndxbwteaz1">
                      <CheckIcon className="h-3.5 w-3.5 text-emerald-700" data-id="element-195" data-mp="3uvmr9ty3i2e3" />
                    </span>
                    {item}
                  </li>)}
              </ul>
            </div>
            <div className="mt-7" data-id="element-196" data-mp="3kz9q6b080m9b">
              <p className="text-sm font-semibold text-slate-600" data-id="element-197" data-mp="3l0bcjbmosv6c">
                Valore totale: <s data-id="element-198" data-mp="3pycx60zrh2jx">€106</s>
              </p>
              <div className="mt-1 flex items-baseline justify-center text-[#241322]" data-id="element-199" data-mp="3bxsbmx2gosmq">
                <span className="font-display text-5xl font-bold" data-id="element-200" data-mp="3bzwmy02owtx1">€</span>
                <strong className="font-display text-8xl font-bold leading-none tracking-tight" data-id="element-201" data-mp="3fyvsnmw8wupj">
                  19
                </strong>
              </div>
              <div className="mt-3 flex flex-wrap justify-center gap-3" data-id="element-202" data-mp="2scjomqdywvlv">
                <span className="bg-emerald-500 px-3 py-1.5 text-xs font-bold uppercase tracking-widest text-white" data-id="element-203" data-mp="36brs3vh5ypvv">
                  Risparmi €87
                </span>
                <span className="py-1.5 text-xs font-bold uppercase tracking-widest text-slate-600" data-id="element-204" data-mp="31bdkgejh5hyd">
                  Pagamento unico
                </span>
                <span className="py-1.5 text-xs font-bold uppercase tracking-widest text-slate-600" data-id="element-205" data-mp="3bbny209f8re2">
                  Accesso a vita
                </span>
              </div>
            </div>
            <a href="https://pilates-pronta.impultienda.ar/checkout" className="cta-button -mx-2 mt-6 block w-[calc(100%+1rem)] rounded-2xl px-6 py-6 text-xl font-bold sm:text-2xl" data-id="element-206" data-mp="3l05vq8memidh">
              SÌ! VOGLIO PILATES PRONTA
            </a>
            <p className="mt-5 flex items-center justify-center gap-1.5 text-xs font-semibold text-slate-600" data-id="element-207" data-mp="3u2x8qcuxhm78">
              <ShieldCheckIcon className="h-4 w-4 text-emerald-700" data-id="element-208" data-mp="hxub9dlcv7s8" />
              Coperto dalla nostra garanzia soddisfatti o rimborsati di 7 giorni
            </p>
            <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 border-t border-emerald-950/10 pt-6 text-xs font-bold text-slate-600" data-id="element-209" data-mp="qrfo2rdymez0">
              <span className="flex gap-1" data-id="element-210" data-mp="vrbv6zhyemis">
                <LockKeyholeIcon className="h-4 w-4" data-id="element-211" data-mp="3v5nufsn55q9k" />
                Pagamento sicuro
              </span>
              <span className="flex gap-1" data-id="element-212" data-mp="31lb89tn4qer">
                <ZapIcon className="h-4 w-4" data-id="element-213" data-mp="32mx79c72xb9" />
                Accesso immediato
              </span>
              <span className="flex gap-1" data-id="element-214" data-mp="cyzro9fkdf72">
                <CreditCardIcon className="h-4 w-4" data-id="element-215" data-mp="d01169gxltmo" />
                Carta · Google Pay · Apple Pay
              </span>
            </div>
          </div>
        </article>
        <p className="mt-5 text-xs font-semibold text-slate-600" data-id="element-216" data-mp="1odwlrxqluula">
          Prezzo finale in euro, pagamento una tantum e accesso immediato al
          materiale digitale.
        </p>
      </div>
    </section>;
}